import { inputs } from '@ecosystem/newron-design-system';

const { RadioButtons } = inputs;

const WithRadio = ({ options, onChange, orientation, ...otherProps }) => {
  return (
    <div data-testid="with-radio-buttons">
      <RadioButtons options={options} onChange={onChange} orientation={orientation} {...otherProps} />
    </div>
  );
};

export default WithRadio;
